import { atom } from "nanostores";

export const SBChatUnread = atom(0);

export const SBChatShow = atom(false);

export const SBChatChannel = atom("");

// The DiDi assistant is a conversation inside the chat panel, not a separate
// widget. It has no SendBird channel, so it can't be represented by
// SBChatChannel — this flag is what the panel routes on, and it takes
// precedence over the selected channel.
export const SBChatAssistant = atom(false);

// Toast notification state
export const SBChatToast = atom<{
  show: boolean;
  message: string;
  sender: string;
  channelUrl: string;
}>({
  show: false,
  message: "",
  sender: "",
  channelUrl: ""
});

// Job relationship data store
export interface JobRelationship {
  appliedJobs: Array<{
    id: number;
    title: string;
    company: string;
    url: string;
    job_type?: string;
  }>;
  invitedJobs: Array<{
    id: number;
    title: string;
    company: string;
    url: string;
    job_type?: string;
  }>;
  tempRequests: Array<{
    id: number;
    title: string;
    company: string;
    url: string;
    job_type?: string;
  }>;
  loading: boolean;
  error: string | null;
}

export const SBChatJobRelationship = atom<JobRelationship>({
  appliedJobs: [],
  invitedJobs: [],
  tempRequests: [],
  loading: false,
  error: null
});
